import { differenceInCalendarDays, parseISO } from 'date-fns';
import { categories } from '../data/categories';
import { creators } from '../data/creators';
import { products } from '../data/products';
import { TODAY } from '../data/store';
import type { Category, CategoryId, Creator, Product } from '../types/catalog';
import { getStatus, isLeavingSoon } from './exhibition';

export function getCreator(id: string): Creator | undefined {
  return creators.find((c) => c.id === id);
}

export function getProduct(id: string): Product | undefined {
  return products.find((p) => p.id === id);
}

export function getCategory(id: CategoryId): Category | undefined {
  return categories.find((c) => c.id === id);
}

export function getProductsByCreator(creatorId: string): Product[] {
  return products.filter((p) => p.creatorId === creatorId);
}

export function getCurrentCreators(): Creator[] {
  return creators.filter((c) => getStatus(c) === 'current');
}

export function getUpcomingCreators(): Creator[] {
  return creators
    .filter((c) => getStatus(c) === 'upcoming')
    .sort((a, b) => a.exhibitionStart.localeCompare(b.exhibitionStart));
}

export function isProductLeavingSoon(product: Product): boolean {
  const creator = getCreator(product.creatorId);
  return creator ? isLeavingSoon(creator) : false;
}

export function isNewProduct(product: Product): boolean {
  return differenceInCalendarDays(TODAY, parseISO(product.addedAt)) <= 30;
}

export function getProductEndDate(product: Product): string | undefined {
  return getCreator(product.creatorId)?.exhibitionEnd;
}
